import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Popover from '@/shared/components/popover/index.vue';
import store from '@/trust-atcs-app/store';
import { PopoverView } from '@/shared/components/popover/popover';
import { orderBy } from 'lodash';

@Options<DropdownWithText>({
  components: {
    Popover
  }
})
export default class DropdownWithText extends Vue {

  @Prop()
  private question!: any;

  private uniqueIdName = null as any;
  private selectedOption = null as any;
  private newWording = '';
  private obj: PopoverView = null as any;
  private subQuestionAnswers: any[] = [];

  private selectedAccountingAppId: any = null as any;
  private selectedTextOption: any = null as any;


  @Watch('selectedOption')
  private onSelectedOptionChanged(): void {
    // mark the selected option
    this.question.responses.forEach((r: any, i: number) => {
      if (r.value == this.selectedOption) {
        this.question.responses[i].answerIsSelected = true;
      } else {
        this.question.responses[i].answerIsSelected = null;
      }
    });

    // // reset the dropdown and text
    if (this.selectedOption != this.question.subQuestionTriggerValue) {
      this.selectedAccountingAppId = null;
      this.question.responses[0].relatedId = null;
      this.question.responses[0].relatedTable = null;
    }

    this.$emit('validForm', this.validForm());
  }

  private selected(value: number): void {
    this.selectedTextOption = null;
    this.question.responses[0].relatedId = null;
    this.question.responses[0].relatedTable = null;
    this.question.responses.forEach((r: any, i: number) => {
      this.question.atcsSubQuestions[i].responses[0].answerTxt = null;
    });
    this.$emit('validForm', this.validForm());
  }

  @Watch('selectedAccountingAppId')
  private onSelectedAccountingAppChanged(): void {

    for (let i = 0; i < this.question.atcsSubQuestions.length; i++) {
      const response = this.question.atcsSubQuestions[i].responses.find(
        (resp: any) => resp.id === this.selectedAccountingAppId
      );
      if (response) {
        // set all responses.answerIsSelected to null
        this.question.atcsSubQuestions[i].responses.forEach((r: any) => {
          r.answerIsSelected = null;
        });
        response.answerIsSelected = true;
        this.question.responses[0].relatedId = response.id;
        this.question.responses[0].relatedTable = response.relatedTable;
      }
    }
    this.$emit('validForm', this.validForm());
  }

  created(): void {
    this.uniqueIdName = 'RadioButtonBranchList' + this.question.id;
    this.initField();
    const content = store.getters.getPopovers;
    this.newWording = this.question.wording;
    if (this.question.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    }
  }

  private initField(): void {
    this.question.responses = orderBy(this.question.responses, 'order', 'asc'); 
    const defaultSelection = this.question.responses.filter((x: any) => x.answerIsSelected);
    if (defaultSelection.length > 0) {
      this.selectedOption = defaultSelection[0].value;
    }
    // get the selectedAccountingAppId from the responses if response.answerIsSelected is true
    if (this.question.atcsSubQuestions?.length > 0) {
      const selectedAccountingAppId = this.question.atcsSubQuestions[0].responses.find(
        (resp: any) => resp.answerIsSelected
      );
      if (selectedAccountingAppId) {
        this.selectedAccountingAppId = selectedAccountingAppId.id;
      }
    }

    this.subQuestionAnswers = this.question.atcsSubQuestions.map((x: any) => x.responses[0].answerTxt);
    this.$emit('validForm', this.validForm());
  }

  private updateSubQuestionAnswer(event: any, i: number): void {
    this.$emit('validForm', this.validForm());
  }

  private validForm(): boolean {
    let valid = false;
    if (this.selectedOption == 1) {
      valid = this.question.responses[0].relatedId != null &&
        this.question.responses[0].relatedTable != null;
    } else if (this.selectedOption == 2) {
      valid = this.question.atcsSubQuestions[1]?.responses[0]?.answerTxt?.length > 0;
    } else if (this.selectedOption == 3) {
      valid = this.question.atcsSubQuestions[2]?.responses[0]?.answerTxt?.length > 0;
    }
    return valid;
  }

}
